var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noData"},[_c('div',[_vm._v("非常抱歉，因发票获取失败无法生成检测报告。可能是企业发票数据量太大所致。")]),_c('div',[_vm._v("如需帮助，请拨打客服热线：0571-85055930")])])
}]

export { render, staticRenderFns }